import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

/**
 * "Page not found": for an address that matches no route.
 *
 * Rendered by the authenticated layout, inside the shell, so a mistyped or
 * stale link keeps the sidebar and the way back; and by the root, for
 * anything outside it.
 */
export function NotFoundState() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center gap-3 py-24 text-center">
      <Icon name="search_off" size={48} className="text-foreground-disabled" />
      <h1 className="text-2xl font-bold">{t('notFound.title')}</h1>
      <p className="text-foreground-secondary max-w-95 text-sm">{t('notFound.description')}</p>
      <Button asChild variant="outline">
        <Link to="/">{t('notFound.back')}</Link>
      </Button>
    </div>
  )
}
